import React from 'react';
import RoundBracketOpen from './RoundBracketOpen';
import RoundBracketClose from './RoundBracketClose';
import LogicOp from './LogicOp';
import Expression from './Expression';

class Group extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {expressions, items, extraFields, parameters, logicOp} = this.props;
        let result = null;

        if (expressions.length === 0) {
            result = (
                <>
                    <RoundBracketOpen />
                    <RoundBracketClose />
                </>
            );
        }

        const last = expressions.length - 1;
        expressions.forEach((expression, index) => {
            if (expression.id === undefined) {
                result = (
                    <>
                        {result}
                        <Group expressions={expression.conditions}
                            items={items} extraFields={extraFields} parameters={parameters}
                            logicOp={index < last ? expression.logicOp : null} />
                    </>
                );
            } else {
                result = (
                    <>
                        {result}
                        <Expression expression={expression}
                            items={items} extraFields={extraFields} parameters={parameters}
                            logicOp={index < last ? expression.logicOp : null} />
                    </>
                );
            }
        });

        if (logicOp) {
            return (
                <>
                    <RoundBracketOpen />
                    {result}
                    <RoundBracketClose />
                    <LogicOp operator={logicOp} />
                </>
            );
        } else {
            return (
                <>
                    <RoundBracketOpen />
                    {result}
                    <RoundBracketClose />
                </>
            );
        }
    }
}

export default Group;
